import "./index";
import axiosInstance from "../../axiosInceptor";

export const getRestaurantCalendar = (
  id: number,
  dateFrom: string,
  dateTo: string
) => {
  try {
    const url = process.env.REACT_APP_OLO_API || "";
    return axiosInstance
      .get(url + `/restaurants/${id}/calendars?from=${dateFrom}&to=${dateTo}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  } catch (error) {
    throw error;
  }
};
